export class OdometerViewModel {
  Mileage: number;
  EngineTime: number;

  init(data?: any) {
    if (data) {
      this.Mileage = data["mileage"];
      this.EngineTime = data["engineTime"];
    }
  }

  static fromJS(data: any): OdometerViewModel {
    data = typeof data === 'object' ? data : {};
    let result = new OdometerViewModel();
    result.init(data);
    return result;
  }
}
